import { useDictionary } from 'models/dictionaryContext';
import { EDictionaryTypes } from 'models/dictionary';
import ApplicationStore from 'state/ApplicationStore';
import { saveApplicationRequest } from 'requests/application';
import { ApplicationStatus } from 'models/application';

export const useApplyWizard = () => {
  const {
    getCivilianPrefix,
    civilianPrefix,
    getGender,
    gender,
    getPhoneCode,
    phoneCode,
    getMake,
    make,
    getMaritalStatus,
    maritalStatus,
    getIdentificationDocumentType,
    identificationDocumentType,
    nationalityAll,
    getNationalityAll,
  } = useDictionary();

  const loadDictionaries = async (types: EDictionaryTypes[]) => {
    if (types.includes(EDictionaryTypes.civilianPrefix)) {
      getCivilianPrefix();
    }
    if (types.includes(EDictionaryTypes.Gender)) {
      getGender();
    }
    if (types.includes(EDictionaryTypes.PhoneCode)) {
      getPhoneCode();
    }
    if (types.includes(EDictionaryTypes.Make)) {
      getMake();
    }
    if (types.includes(EDictionaryTypes.MaritalStatus)) {
      getMaritalStatus();
    }
    if (types.includes(EDictionaryTypes.IdentificationDocumentType)) {
      getIdentificationDocumentType();
    }
    if (types.includes(EDictionaryTypes.Nationality)) {
      getNationalityAll();
    }
  };

  const saveApplication = async () => {
    const { attachmentsData, ...rest } = ApplicationStore._data.formData;

    const request = {
      name: 'Certificate to Possess a Shotgun',
      isDraft: false,
      status: ApplicationStatus.NewApplication,
      data: JSON.stringify(rest),
    };

    return saveApplicationRequest({ request, attachments: attachmentsData });
  };

  return {
    loadDictionaries,
    civilianPrefix,
    gender,
    phoneCode,
    make,
    maritalStatus,
    identificationDocumentType,
    saveApplication,
    nationalityAll,
  };
};
